<template>
  <v-row>
    <v-col cols="12" v-if="debtStateEnded">
      <p class="text-center ma-0"
         :class="{'ok-title small' : $vuetify.breakpoint.smAndDown, 'text-h3' : $vuetify.breakpoint.mdAndUp }"
         v-if="debt.debtSummary.state.state === 8">
        {{ $t('paidText') }}
      </p>
      <p class="text-center ma-0"
         :class="{'ok-title small' : $vuetify.breakpoint.smAndDown, 'text-h3' : $vuetify.breakpoint.mdAndUp }"
         v-if="debt.debtSummary.state.state === 9">
        {{ $t('endedText') }}
      </p>
      <p class="text-center ma-0"
         :class="{'ok-title small' : $vuetify.breakpoint.smAndDown, 'text-h3' : $vuetify.breakpoint.mdAndUp }"
         v-if="debt.debtSummary.state.state === 10">
        {{ $t('groundlessText') }}
      </p>
    </v-col>
    <v-col cols="12" class="text-center" ref="wheelParent" v-if="!debt.debtSummary.state.ended">
      <debt-wheel :value="hasActivePaymentPlan ? debt.paymentPlan.summary.progress : debt.debtSummary.progress"
                  :size=wheelSize
                  :width=wheelWidth
                  :rotate="-90"
                  :segments="hasActivePaymentPlan ? debt.paymentPlan.installments.length : 0"
                  color="primary">
        <div class="d-flex flex-column text-center color-new-body-grey--text">
          <p class="mb-2">{{ $t('left') }}</p>
          <p class="ok-subtitle large mb-2" v-if="hasActivePaymentPlan">{{ debt.paymentPlan.summary.left | currency }}</p>
          <p class="ok-subtitle large mb-2" v-else>{{ debt.debtSummary.left | currency }}</p>
          <p class="mb-2" v-if="hasActivePaymentPlan">
            {{ debt.paymentPlan.installments.length - (debt.paymentPlan.nextInstallment.sequence - 1) }} / {{ debt.paymentPlan.installments.length }} {{ $t('installments') }}
          </p>
          <p class="mb-2" v-else>{{ $t('paid') }} {{debt.debtSummary.totalPaid | currency }}</p>
        </div>
      </debt-wheel>
    </v-col>
    <v-col cols="12" class="text-center" v-else>
      <v-icon x-large color="color-green">
        fas fa-check
      </v-icon>
    </v-col>
    <v-col cols="6" sm="12" lg="6" v-if="debt.debtSummary.state.ended">
      <p class="ok-title" v-if="debt.debtSummary.state.state === 8">{{ $t('paymentDate') }}</p>
      <p class="ok-title" v-else>{{ $t('endDate') }}</p>
      <p class="ok-subtitle small">{{ debt.endDate | formatDate }}</p>
    </v-col>
    <v-col :cols="hasActivePaymentPlan ? 6 : 12" :class="{ 'text-center': !hasActivePaymentPlan }" v-if="$vuetify.breakpoint.smAndDown && debt.dueDate != null && !debt.debtSummary.state.ended">
      <p class="ok-title">{{ $t('dueDate') }}</p>
      <p class="ok-subtitle">{{ debt.dueDate | formatDate }}</p>
    </v-col>
    <v-col cols="6" v-if="$vuetify.breakpoint.smAndDown && hasActivePaymentPlan">
      <p class="ok-title">{{ $t('amountToPay') }}</p>
      <p class="ok-subtitle">{{ nextInstallment.eur - nextInstallment.paid | currency }}</p>
    </v-col>
    <template v-if="$vuetify.breakpoint.smAndDown && debt.debtSummary.state.state === 6">
      <v-col cols="12" v-if="debt.debtReliefTotalSum !== null">
        <p class="ok-title">{{ $t('debtReliefTotalSum') }}</p>
        <p class="ok-subtitle small">{{debt.debtReliefTotalSum | currency}}</p>
      </v-col>
      <v-col cols="12" v-if="debt.orderDebtRestructuringDebtID !== null">
        <p class="ok-title">{{ $t('orderDebtRestructuringDebtID') }}</p>
        <p class="ok-subtitle small">{{debt.orderDebtRestructuringDebtID}}</p>
      </v-col>
    </template>
  </v-row>
</template>

<script>
  export default {
    props: ['debt'],
    data: function () {
      return {
        wheelSize: 225,
        wheelWidth: 15
      }
    },
    computed: {
      hasActivePaymentPlan () {
        return this.debt.paymentPlan !== null
      },
      nextInstallment () {
        return this.debt.paymentPlan.nextInstallment
      },
      debtStateEnded () {
        return this.debt.debtSummary.state.ended && (this.debt.debtSummary.state.state === 8 || this.debt.debtSummary.state.state === 9 || this.debt.debtSummary.state.state === 10)
      }
    },
    methods: {
      /* calculateWheelSize () {
        this.$nextTick(function () {
          console.log(this.$refs.wheelParent)
          console.log(this.$refs.wheelParent.clientWidth)
          console.log(this.$refs.wheelParent.innerWidth)
          var width = this.$refs.wheelParent.clientWidth
          if (width <= 300) {
            this.wheelSize = width
          } else {
            this.wheelSize = 225
          }
        })
      } */
    }
  }
</script>

<i18n>
  {
  "fi": {
  "sds-text-1": "Avoin saldo",
  "paidText": "Velka maksettu",
  "endedText": "Velka lopetettu",
  "groundlessText": "Velka aiheeton",
  "endDate": "Lopetuspvm"
  },
  "se": {
  "sds-text-1": "Öppet saldo",
  "paidText": "Skulden betald",
  "endedText": "Avslutat ärende",
  "groundlessText": "Obefogad skuld",
  "endDate": "Avslutningsdag"
  },
  "en": {
  "sds-text-1": "Unpaid amount",
  "paidText": "Debt paid",
  "endedText": "Case closed",
  "groundlessText": "Case closed",
  "endDate": "End date"
  }
  }
</i18n>
